import { call, put, takeEvery } from 'redux-saga/effects';
import { getBikeVariants } from '../../requests/get_bike_variants_request';
import { getBikeModelVariantsRequestSuccess, getBikeModelVariantsRequestFailure } from '../actions/get_bike_model_variants.actions';
import { GET_BIKE_MODEL_VARIANTS_REQUEST } from '../constants/bike_model_variants.constants';
import { message_error } from '../../../../../components/Message';

function* getBikeModelVariantsRequest({ model_id }) {
    const variants = yield call(getBikeVariants, model_id); const
        { msg } = variants;
    if (variants) {
        yield put(getBikeModelVariantsRequestSuccess(variants));
    } else {
        yield put(getBikeModelVariantsRequestFailure(msg));
        message_error(msg);
    }
}

export default function* modelVariantsSaga() {
    yield takeEvery(GET_BIKE_MODEL_VARIANTS_REQUEST, getBikeModelVariantsRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/redux/sagas/get_bike_model_variants.saga.js